export enum Launch_Play_N_Go {
  "pt_BR" = "pt_BR",
  "es_ES" = "es_ES",
  "hu" = "hu",
}
